export class CoreEntity {
  constructor(_index) {
    this._index = _index;
  }
  index() {
    return this._index;
  }
}
